import { EventDispatcher } from 'three';
import { invalidate } from '@react-three/fiber';

export enum EditorEventType {
  POINTER_MISSED = 'pointerMissed',
  PAN_CHANGED = 'panChanged',
  ZOOM_CHANGED = 'zoomChanged',
  ZOOM_IN = 'zoomIn',
  ZOOM_OUT = 'zoomOut',
  FIT_SCENE = 'fitScene',
}

type BaseEvent<T extends EditorEventType> = { type: T };

type EventMap = {
  [EditorEventType.POINTER_MISSED]: BaseEvent<EditorEventType.POINTER_MISSED>;
  [EditorEventType.PAN_CHANGED]: BaseEvent<EditorEventType.PAN_CHANGED>;
  [EditorEventType.ZOOM_CHANGED]: BaseEvent<EditorEventType.ZOOM_CHANGED>;
  [EditorEventType.ZOOM_IN]: BaseEvent<EditorEventType.ZOOM_IN>;
  [EditorEventType.ZOOM_OUT]: BaseEvent<EditorEventType.ZOOM_OUT>;
  [EditorEventType.FIT_SCENE]: BaseEvent<EditorEventType.FIT_SCENE>;
};

export class EditorDispatcher extends EventDispatcher<EventMap> {
  pointerMissed() {
    this.dispatchEvent({ type: EditorEventType.POINTER_MISSED });
  }

  panChanged() {
    invalidate();
    this.dispatchEvent({ type: EditorEventType.PAN_CHANGED });
  }

  zoomChanged() {
    invalidate();
    this.dispatchEvent({ type: EditorEventType.ZOOM_CHANGED });
  }

  zoomIn() {
    invalidate();
    this.dispatchEvent({ type: EditorEventType.ZOOM_IN });
  }

  zoomOut() {
    invalidate();
    this.dispatchEvent({ type: EditorEventType.ZOOM_OUT });
  }

  fitScene() {
    invalidate();
    this.dispatchEvent({ type: EditorEventType.FIT_SCENE });
  }
}

export const dispatcher = new EditorDispatcher();
